

<div class="page-padding">
  <div class="panel">

    <div class="panel__header">
      <span class="panel__header__title">{{'Search'}}</span>
    </div>
          <div class="step-container">
            <div class="margin-bottom-24">
              <mat-card class = "panel_search mat-card" >
                <form class="example-form">
                <mat-form-field class="example-full-width" >
                <mat-select  name="jobrole_"  placeholder="{{'Position'}}" [(ngModel)]="positionID" (selectionChange)="onSelectPosition($event)">
                  <!-- <mat-option (click)="onClear()" >None</mat-option>                  -->
                  <mat-option *ngFor="let position of jobPositionList" [value]="position.Id" >
                  {{position.positionName}}</mat-option>
                </mat-select>
               </mat-form-field>

              
              <mat-form-field class="example-full-width">
                <input matInput placeholder="{{'Position Name'}}" type="text" [(ngModel)]="positionName" name = "positionName" required>
              </mat-form-field>

              <mat-form-field class="example-full-width">
                <input matInput placeholder="{{'Created By'}}" type="text" [(ngModel)]="createdBy" name ="createdby" [readonly]="!!createdBy" >
              </mat-form-field>

              <mat-form-field class="example-full-width">
                <mat-label>Position Details</mat-label>
                <textarea matInput [(ngModel)]="positionDetails" name ="positionDetails"></textarea>
              </mat-form-field>

            
              <mat-checkbox class="margin-right-16" [(ngModel)]="isActive" name ="active" ngDefaultControl (change)="ChangeCheckbox($event)">{{'Active'}}</mat-checkbox>
              
              <div>
                <button (click) = "addNewPosition()" mat-raised-button [disabled]="btnDisabledAdd">{{'Add' }}</button>
                <button (click)="updatePosition()" mat-raised-button [disabled]="btnDisabledUpdate" >{{'Update' }}</button>
                <button (click) = "deletePosition()"mat-raised-button [disabled]="btnDisabledDelete" >{{'Delete'}}</button>
                <button mat-raised-button (click)="resetFields()" >{{'Reset' }}</button>
                <!-- <button mat-raised-button (click)="resetFields()" >{{'Reset' }}</button> -->
              </div>
              </form>
             </mat-card>    
            </div>           
        </div>
    
       
        <div>
          

          <mat-card>
            <mat-tab-group>
              <mat-tab >
                <ng-template mat-tab-label>
                  <mat-icon class="material-icons button__icon" style="vertical-align: middle; margin-right: 8px; font-size: 25px;">face</mat-icon>
                  Add User
                </ng-template>

                  <div class="panel__content">
                    <div>
                      <button (click) = "UpdateSafetyUserPositions()" mat-raised-button >{{'Update' }}</button>
                  </div>
                    <mat-table [dataSource]="dataSourceUser" matSort class="mat-elevation-z8"style=" margin: 5px; width:50%; "  >
             
                      <!-- <ng-container matColumnDef="UserName">
                        <mat-header-cell  *matHeaderCellDef >User Name</mat-header-cell>
                        <mat-cell *matCellDef="let element"><div class="SerialAndUnitText">{{element.UserName}}</div></mat-cell>
                      </ng-container> -->
                    
                      <ng-container matColumnDef="FullName">
                        <mat-header-cell *matHeaderCellDef >Full Name</mat-header-cell>
                        <mat-cell *matCellDef="let element">{{element.FullName}}</mat-cell>
                      </ng-container>

                      <ng-container matColumnDef="USI">
                        <mat-header-cell  *matHeaderCellDef > USI</mat-header-cell>
                        <mat-cell *matCellDef="let element"><div class="SerialAndUnitText">{{element.USI}}</div></mat-cell>
                      </ng-container>
                     
                      <ng-container matColumnDef="select">
                      
                        <th mat-header-cell *matHeaderCellDef>
                          <mat-checkbox (change)="$event ? masterToggleUser() : null"
                            [checked]="selectionUser.hasValue()" 
                            [indeterminate]="selectionUser.hasValue() && !isAllSelectedUser()" >
                          </mat-checkbox>
                        </th>
                        <td mat-cell *matCellDef="let element">             
                          <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selectionUser.toggle(element) : null"
                            [checked]="element.select" [(ngModel)]="element.select">
                          </mat-checkbox>
                        </td>


                      </ng-container>
        
                          
                      <mat-header-row *matHeaderRowDef="displayedColumnsUser"></mat-header-row>
                      <mat-row *matRowDef="let row; columns: displayedColumnsUser;" (click)="selectionUser.toggle(row)"></mat-row>
                    </mat-table>
                 
                  </div>
              </mat-tab>
              <mat-tab>
                <ng-template mat-tab-label>
                  <mat-icon class="material-icons button__icon" style="vertical-align: middle; margin-right: 8px; font-size: 25px;">list_alt</mat-icon>
                  Add Form
                </ng-template>
                <div class="panel__content">
                  <div>
                    <button (click) = "UpdateSafetFormPosition()" mat-raised-button >{{'Update' }}</button>
                </div>
                  <mat-table [dataSource]="dataSourceForm" matSort class="mat-elevation-z8"style=" margin: 5px; width:50%; "  >
           
                    <ng-container matColumnDef="FormName">
                      <mat-header-cell  *matHeaderCellDef> Form Name</mat-header-cell>
                      <mat-cell *matCellDef="let element"><div class="SerialAndUnitText">{{element.FormName}}</div></mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="FormCategory">
                      <mat-header-cell  *matHeaderCellDef >Form Category</mat-header-cell>
                      <mat-cell *matCellDef="let element"><div class="SerialAndUnitText">{{element.FormCategory}}</div></mat-cell>
                    </ng-container>
                                                 
                    <ng-container matColumnDef="isDigital">
                      <mat-header-cell *matHeaderCellDef >Form Type</mat-header-cell>
                      <!-- <i *ngIf="sr.IsDigitalForm == true" class="material-icons">dynamic_form</i>
                      <i (click)="onClickDownloadForm(sr)" *ngIf="sr.IsDigitalForm != true"
                        class="material-icons">picture_as_pdf</i> -->                                                                                 
                        
                          <mat-cell *matCellDef="let element">
                            <ng-container *ngIf="element.isDigital == true">
                              <i  class="material-icons">dynamic_form</i>
                            </ng-container>
                            <ng-container *ngIf="element.isDigital == false">
                              <i  class="material-icons">picture_as_pdf</i>
                            </ng-container>                        
                          </mat-cell>                                          
                    </ng-container>
                                        
                    <ng-container matColumnDef="select"> 
                      <th mat-header-cell *matHeaderCellDef>
                        <mat-checkbox
                          (change)="$event ? masterToggleForm() : null"
                          [checked]="selectionForm.hasValue()"   
                          [indeterminate]="selectionForm.hasValue() &&  !isAllSelectedForm()"
                        >
                        </mat-checkbox>
                      </th>
                      <td mat-cell *matCellDef="let element">
                        <mat-checkbox
                          (click)="$event.stopPropagation()"
                          (change)="$event ? selectionForm.toggle(element) : null"
                          [checked]="element.select" [(ngModel)]="element.select"
                        >
                        </mat-checkbox>                       
                      </td>             
                    </ng-container>
                             
                    <mat-header-row *matHeaderRowDef="displayedColumnsForm"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumnsForm;" (click)="selectionForm.toggle(row)"></mat-row>
                  </mat-table>
               
                </div>
                <div class="panel__content">
               
                </div>
            </mat-tab>
              </mat-tab-group>
         
           
          </mat-card>

         
          </div>   
  </div>
    </div>
  